import { convertBoolean } from 'coreOld/utils';

export const mapUnknownManufacturers = (manufacturers) => {
  return manufacturers.map((item) => ({
    name: item,
  }));
};

export const mapUnknownManufacturersToValue = (manufacturers, value) => {
  if (!manufacturers) {
    return;
  }

  return manufacturers.reduce((obj, field) => ({ ...obj, [field.name]: value }), {});
};

export const mapUnknownManufacturersToSend = (manufacturers) => {
  Object.keys(manufacturers).forEach(
    (item) => (manufacturers[item] = manufacturers[item]?.id || '')
  );

  return manufacturers;
};

export const mapOmitsToSend = (omits) => {
  Object.keys(omits).forEach((item) => (omits[item] = convertBoolean(omits[item])));

  return omits;
};
